import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useEffect } from "react";
import { useModal } from "../../hooks";
function __Modal({ children , className , onOpen , onClose , ariaModal =true  }, ref) {
    const { isOpen , close , setReturnValue  } = useModal();
    const closeOnEscape = (e)=>{
        if (e.key === "Escape") close();
    };
    useEffect(()=>{
        window.addEventListener("keydown", closeOnEscape);
        return ()=>{
            window.removeEventListener("keydown", closeOnEscape);
        };
    });
    useEffect(()=>{
        if (isOpen) {
            onOpen && onOpen();
        } else {
            onClose && onClose();
        }
    }, [
        isOpen
    ]);
    const onCloseFn = (e)=>{
        e.preventDefault();
        setReturnValue(e.currentTarget.returnValue);
        close();
    };
    return /*#__PURE__*/ _jsx("dialog", {
        open: isOpen,
        onClose: onCloseFn,
        ref: ref,
        className: className,
        "aria-modal": ariaModal,
        children: isOpen && children
    });
}
export const Modal = /*#__PURE__*/ forwardRef(__Modal);
